/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './CoInsurance.scss'
import { CommonUtils } from '../../../../utils/CommonUtils'
import { IInpatientTypeInsurance } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface ICoInsuranceProps {
	data: IInpatientTypeInsurance
}
export class CoInsurance extends React.Component<ICoInsuranceProps> {
	renderCoInsurance = (val: IInpatientTypeInsurance): JSX.Element[] | null => {
		if (!val || !val.coInsurances || val.coInsurances.length === 0) {
			return null
		}

		return val.coInsurances.map((coIns, index) => {
			return (
				<tr key={index}>
					<td>{index === 0 ? 'Co-Insurance:' : ''}</td>
					<td colSpan={3} className="bottom-border-td">
						<strong>{coIns.percent * 100}%</strong> for {CommonUtils.DateRange(coIns.startDate, coIns.endDate, true)}
						{typeof coIns.message !== 'undefined' && coIns.message !== null ? coIns.message : ''}
					</td>
				</tr>
			)
		})
	}

	render(): React.ReactNode {
		const CoInsuranceModel = this.props.data
		return this.renderCoInsurance(CoInsuranceModel)
	}
}
